import { connect } from "react-redux";
import { withTranslation } from "@template/components/translation";
import { getDefaultStoreUrl } from "@template/state/modules/regionalStore";
import AccessibilityLinks from "./AccessibilityLinks";

const mapStateToProps = state => ({
  defaultStoreUrl: getDefaultStoreUrl(state)
});

export default connect(mapStateToProps)(withTranslation(AccessibilityLinks));
